import { Badge } from '@civilgrid/ui/Badge';
import { useParams } from '@tanstack/react-router';
import { capturePosthogEvent, POSTHOG_EVENTS } from '~/common/posthogEvents';
import { useGetProject } from '~/hooks/useGetProject';
import { useProjectIntelligence } from '~/hooks/useProjectIntelligence';
import { getFormattedConflictCount } from '../../../common';

export function ConflictSummary({ onConflictClick }: { onConflictClick: (conflictType: string) => void }) {
  const { projectId } = useParams({ strict: false });

  const { data: project } = useGetProject({ projectId });
  const { data: projectIntelligence } = useProjectIntelligence({ projectId });

  const pavingConflicts = projectIntelligence?.intelligenceSummary?.conflictWindow?.counts?.paving || 0;
  const pavingMoratoriaConflicts = projectIntelligence?.intelligenceSummary?.conflictWindow?.counts?.moratoria || 0;
  const cipConflicts = projectIntelligence?.intelligenceSummary?.conflictWindow?.counts?.cip || 0;

  const trackAndSelectConflict = (section: string) => {
    capturePosthogEvent(POSTHOG_EVENTS.intelligenceV2ConflictSectionJumped, {
      project_id: projectId,
      organization_id: project?.organization,
      conflict_section: section,
    });
    onConflictClick(section);
  };

  return (
    <div className="flex flex-col gap-2 pb-3 text-xs border-b">
      <div className="flex flex-row justify-between">
        <button
          className="cursor-pointer text-xs text-grey-60 underline"
          data-testid="conflict-summary-jump-paving-projects"
          type="button"
          onClick={() => trackAndSelectConflict('paving-projects')}
        >
          Paving Projects
        </button>
        <Badge color={pavingConflicts === 0 ? 'green' : 'red'}>{getFormattedConflictCount(pavingConflicts)}</Badge>
      </div>
      <div className="flex flex-row justify-between">
        <button
          className="cursor-pointer text-xs text-grey-60 underline"
          data-testid="conflict-summary-jump-paving-moratoria"
          type="button"
          onClick={() => trackAndSelectConflict('paving-moratoria')}
        >
          Paving Moratoria
        </button>
        <Badge color={pavingMoratoriaConflicts === 0 ? 'green' : 'red'}>
          {getFormattedConflictCount(pavingMoratoriaConflicts)}
        </Badge>
      </div>
      <div className="flex flex-row justify-between">
        <button
          className="cursor-pointer text-xs text-grey-60 underline"
          data-testid="conflict-summary-jump-capital-improvement-projects"
          type="button"
          onClick={() => trackAndSelectConflict('capital-improvement-projects')}
        >
          Capital Improvement Projects
        </button>
        <Badge color={cipConflicts === 0 ? 'green' : 'yellow'}>{getFormattedConflictCount(cipConflicts)}</Badge>
      </div>
    </div>
  );
}
